// src/utils/authFetch.js
export async function authFetch(url, options = {}) {
    const res = await fetch(url, {
      ...options,
      credentials: 'include',
    });
  /*
    if (res.status === 403) {
      window.location.href = '/'; // logout forzato
      return null;
    }
  */
    return res;
  }
  